import { render, staticRenderFns } from "./DataSourceSelector.vue?vue&type=template&id=2a1427c5&scoped=true"
import script from "./DataSourceSelector.vue?vue&type=script&lang=js"
export * from "./DataSourceSelector.vue?vue&type=script&lang=js"
import style0 from "./DataSourceSelector.vue?vue&type=style&index=0&id=2a1427c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1427c5",
  null
  
)

export default component.exports